export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

interface Props {
    value?: string
}

const code = `function test() {
    console.log('hello world');
}`;

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            value: code
        }
    }
}